(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Featured video lazy-play
    document.querySelectorAll('.d1-home-carousel__featured-video').forEach((video) => {
      const root = video.closest('[data-d1-home-carousel]');
      const replay = root ? root.querySelector('.d1-home-carousel__featured-replay') : null;
      let hasEnded = false;

      const markEnded = () => {
        hasEnded = true;
        video.classList.add('is-ended');
      };
      video.addEventListener('ended', markEnded);

      const tryPlay = () => {
        const p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => markEnded());
        }
      };

      if (replay) {
        replay.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          hasEnded = false;
          video.classList.remove('is-ended');
          try {
            video.currentTime = 0;
          } catch (e) {}
          tryPlay();
        });
      }

      if (reducedMotion) {
        markEnded();
        return;
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
              if (visible) {
                if (!hasEnded && video.paused) tryPlay();
              } else if (!video.paused) {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.35, 0.6] }
        );
        io.observe(video);
      } else {
        tryPlay();
      }
    });

    // Product card track scroll + nav
    document.querySelectorAll('[data-d1-home-carousel]').forEach((root) => {
      const track = root.querySelector('[data-d1-home-carousel-track]');
      const nav = root.querySelector('[data-d1-home-carousel-nav]');
      if (!track || !nav) return;

      const prevBtn = nav.querySelector('.d1-home-carousel__nav-btn--prev');
      const nextBtn = nav.querySelector('.d1-home-carousel__nav-btn--next');

      const getStep = () => {
        const card = track.querySelector('.d1-home-carousel__card');
        if (!card) return track.clientWidth * 0.8;
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 24;
        return card.getBoundingClientRect().width + gap;
      };

      const updateNav = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        const canScroll = maxScroll > 8;
        nav.hidden = !canScroll;
        if (!canScroll) return;
        const left = track.scrollLeft;
        if (prevBtn) prevBtn.disabled = left <= 4;
        if (nextBtn) nextBtn.disabled = left >= maxScroll - 4;
      };

      const scrollByDir = (dir) => {
        track.scrollBy({
          left: dir * getStep(),
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      };

      prevBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollByDir(-1);
      });
      nextBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollByDir(1);
      });

      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav, { passive: true });
      updateNav();
      // Images/fonts can change scrollWidth after first paint
      requestAnimationFrame(updateNav);
      setTimeout(updateNav, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d1-contact-form"] && !Shopify.designMode) return;
  try {
    
  function updateD1ContactSubject(form) {
    const topicField = form.querySelector('[data-topic-field]');
    const subjectField = form.querySelector('[data-subject-field]');

    if (!topicField || !subjectField) return;

    const topic = topicField.value && topicField.value.trim() !== '' ? topicField.value.trim() : 'General enquiry';
    subjectField.value = `Contact us | ${topic}`;
  }

  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-d1-contact-form]');
    if (!form) return;

    if (event.target.matches('[data-topic-field]')) {
      updateD1ContactSubject(form);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-d1-contact-form]');
    if (!form) return;

    const honeypotField = form.querySelector('[data-honeypot-field]');
    if (honeypotField && honeypotField.value.trim() !== '') {
      event.preventDefault();
      return;
    }

    updateD1ContactSubject(form);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    var mobileInput = document.querySelector('[data-d1-mobile-search]');
    var desktopInput = document.querySelector('[data-d1-desktop-search]');
    var details = document.querySelector('.header__icons .header__search--drawer details')
      || document.querySelector('.header__search--drawer details');
    if (!details || (!mobileInput && !desktopInput)) return;

    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function currentInput() {
      return mobileQuery.matches ? mobileInput : desktopInput;
    }

    function setDropdownOffset() {
      var header = document.querySelector('.section-header');
      if (!header) return;
      var offset = Math.round(header.getBoundingClientRect().bottom) + 'px';
      var root = document.documentElement;
      if (mobileQuery.matches) {
        root.style.setProperty('--d1-mobile-search-offset', offset);
        return;
      }
      root.style.setProperty('--d1-desktop-search-offset', offset);
      var pill = document.querySelector('.d1-desktop-search');
      var compact = document.body.classList.contains('d1-header-search-compact');
      if (pill && !compact && pill.offsetParent) {
        var box = pill.getBoundingClientRect();
        root.style.setProperty('--d1-desktop-search-left', Math.round(box.left) + 'px');
        root.style.setProperty('--d1-desktop-search-right', 'auto');
        root.style.setProperty('--d1-desktop-search-width', Math.round(box.width) + 'px');
        return;
      }
      root.style.removeProperty('--d1-desktop-search-left');
      root.style.removeProperty('--d1-desktop-search-right');
      root.style.removeProperty('--d1-desktop-search-width');
    }

    function syncAlgolia(value) {
      var aa = details.querySelector('.aa-Input');
      if (!aa) return false;
      var proto = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
      if (proto && proto.set) proto.set.call(aa, value);
      else aa.value = value;
      aa.dispatchEvent(new Event('input', { bubbles: true }));
      return true;
    }

    var openedAt = 0;

    function openDropdown() {
      var input = currentInput();
      if (!input) return;
      openedAt = Date.now();
      setDropdownOffset();
      if (mobileQuery.matches) {
        document.body.classList.add('d1-mobile-search-open', 'overflow-hidden');
      } else {
        document.body.classList.add('d1-desktop-search-open', 'overflow-hidden');
      }
      if (!details.open) details.setAttribute('open', '');
      if (!syncAlgolia(input.value)) {
        window.setTimeout(function () {
          syncAlgolia(input.value);
        }, 80);
      }
    }

    function closeDropdown() {
      document.body.classList.remove('d1-mobile-search-open', 'd1-desktop-search-open', 'overflow-hidden');
      if (details.open) details.removeAttribute('open');
    }

    function bindSearchField(input, clearSelector) {
      if (!input) return;
      var clearBtn = document.querySelector(clearSelector);

      function syncClear() {
        if (!clearBtn) return;
        clearBtn.hidden = !String(input.value || '').trim();
      }

      input.addEventListener('focus', openDropdown);
      input.addEventListener('input', function () {
        openDropdown();
        syncAlgolia(input.value);
        syncClear();
      });
      if (clearBtn) {
        clearBtn.addEventListener('click', function (event) {
          event.preventDefault();
          input.value = '';
          syncAlgolia('');
          syncClear();
          input.focus();
        });
      }
      if (input.form) {
        input.form.addEventListener('submit', function (event) {
          if (!String(input.value || '').trim()) event.preventDefault();
        });
      }
      syncClear();
    }

    bindSearchField(mobileInput, '[data-d1-mobile-search-clear]');
    bindSearchField(desktopInput, '[data-d1-desktop-search-clear]');

    document.addEventListener('click', function (event) {
      if (!details.open) return;
      if (Date.now() - openedAt < 250) return;
      if (event.target.closest('.d1-mobile-search') || event.target.closest('.d1-desktop-search')) return;
      if (event.target.closest('.header__icon--search')) return;
      if (event.target.closest('.search-drawer__panel')) return;
      closeDropdown();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && details.open) closeDropdown();
    });

    function restorePillQuery() {
      if (document.body.classList.contains('d1-header-search-compact')) {
        var aa = details.querySelector('.aa-Input');
        if (aa) aa.focus({ preventScroll: true });
        return;
      }
      var input = currentInput();
      if (!input) return;
      syncAlgolia(input.value);
      input.focus({ preventScroll: true });
    }

    details.addEventListener('toggle', function () {
      if (details.open) {
        openedAt = Date.now();
        if (mobileQuery.matches) {
          document.body.classList.add('d1-mobile-search-open', 'overflow-hidden');
        } else {
          document.body.classList.add('d1-desktop-search-open', 'overflow-hidden');
        }
        setDropdownOffset();
        window.requestAnimationFrame(function () {
          window.setTimeout(restorePillQuery, 0);
        });
        return;
      }
      document.body.classList.remove('d1-mobile-search-open', 'd1-desktop-search-open', 'overflow-hidden');
    });

    window.addEventListener('resize', function () {
      if (details.open) setDropdownOffset();
    });

    document.addEventListener(
      'wheel',
      function (event) {
        if (
          !document.body.classList.contains('d1-desktop-search-open') &&
          !document.body.classList.contains('d1-mobile-search-open')
        ) {
          return;
        }
        var panel = event.target.closest('.search-drawer__panel');
        if (!panel) {
          event.preventDefault();
          return;
        }
        var scroller = panel.querySelector('.search-drawer__body') || panel;
        var delta = event.deltaY;
        var atTop = scroller.scrollTop <= 0;
        var atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;
        if ((delta < 0 && atTop) || (delta > 0 && atBottom) || scroller.scrollHeight <= scroller.clientHeight) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-hero-banner"] && !Shopify.designMode) return;
  try {
    
  if (!window.D1PageHeroAnchorInit) {
    window.D1PageHeroAnchorInit = true;

    var FALLBACK_SELECTORS = {
      form: ['#form', '.d1-pm-form-wrapper', '[data-d1-pm-form]', '.d1-contact-form-wrapper', '[data-d1-contact-form]', 'form'],
      process: ['#process', '.page-steps'],
      contact: ['#contact', '.d1-contact-form-wrapper', '[data-d1-contact-form]'],
      faq: ['#faq', '.faq-contact', '.faq']
    };

    function findHashTarget(hash) {
      if (!hash || hash === '#' || hash === '#0') return null;

      var key = hash.replace(/^#/, '').toLowerCase();
      var selectors = FALLBACK_SELECTORS[key] ? FALLBACK_SELECTORS[key].slice() : [];

      try {
        var byId = document.querySelector(hash);
        if (byId) return byId;
      } catch (error) {}

      for (var i = 0; i < selectors.length; i++) {
        try {
          var el = document.querySelector(selectors[i]);
          if (el) return el;
        } catch (error) {}
      }

      return null;
    }

    function scrollToTarget(target, hash, updateHistory) {
      if (!target) return false;

      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      if (updateHistory && hash && window.history && window.history.pushState) {
        window.history.pushState(null, '', hash);
      }

      return true;
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-phb-link], a[href^="#"]');
      if (!link) return;

      var href = link.getAttribute('data-phb-link') || link.getAttribute('href') || '';
      if (!href || href.indexOf('#') === -1) return;

      var hashIndex = href.indexOf('#');
      var beforeHash = href.slice(0, hashIndex);
      var hash = href.slice(hashIndex);

      if (beforeHash) {
        try {
          var url = new URL(href, window.location.href);
          var samePage =
            url.origin === window.location.origin &&
            url.pathname === window.location.pathname;
          if (!samePage) return;
        } catch (error) {
          return;
        }
      }

      var target = findHashTarget(hash);
      if (!target) return;

      event.preventDefault();
      scrollToTarget(target, hash, true);
    });

    function tryInitialHashScroll() {
      if (!window.location.hash) return;

      var attempts = 0;
      var maxAttempts = 12;

      function attempt() {
        attempts += 1;
        var target = findHashTarget(window.location.hash);

        if (target) {
          scrollToTarget(target, null, false);
          return;
        }

        if (attempts < maxAttempts) {
          window.setTimeout(attempt, 250);
        }
      }

      attempt();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryInitialHashScroll, { once: true });
    } else {
      tryInitialHashScroll();
    }

    window.addEventListener('hashchange', function () {
      var target = findHashTarget(window.location.hash);
      if (target) scrollToTarget(target, null, false);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utility-link-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function injectAll() {
      var drawers = document.querySelectorAll('.menu-drawer__utility-links');
      if (!drawers.length) return;
      var templates = document.querySelectorAll('template[id^="UtilityLinkBarMobile-"]');
      if (!templates.length) return;

      drawers.forEach(function (drawer) {
        templates.forEach(function (tpl) {
          var sectionId = tpl.id.replace('UtilityLinkBarMobile-', '');
          var node = tpl.content.firstElementChild;
          if (!node) return;

          var existing = drawer.querySelector(
            '[data-utility-link-bar-mobile][data-section-id="' + sectionId + '"]'
          );
          if (existing) existing.remove();

          drawer.insertBefore(node.cloneNode(true), drawer.firstChild);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectAll);
    } else {
      injectAll();
    }

    document.addEventListener('shopify:section:load', injectAll);
    document.addEventListener('shopify:section:reorder', injectAll);

    document.addEventListener('shopify:section:unload', function (event) {
      var sectionId = event && event.detail && event.detail.sectionId;
      if (!sectionId) return;
      document
        .querySelectorAll(
          '[data-utility-link-bar-mobile][data-section-id="' + sectionId + '"]'
        )
        .forEach(function (n) {
          n.remove();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
